import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class CheckAmbulanciaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getChecksAmbulancia(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckAmbulancia(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckAmbulanciaByUnidade(unidade_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/unidade/' + unidade_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckAmbulanciaByUsuario(usuario_id, filtro={}, pagina=1) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/usuario/' + usuario_id + '/' + pagina + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}


	getCheckAmbulanciaByRegiao(usuario_id, filtro={}, pagina=1) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/regiao/' + usuario_id + '/' + pagina + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckAmbulanciaQtde(usuario_id, filtro) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/usuario_qtde/' + usuario_id + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}


	getCheckAmbulanciaRegiaoQtde(usuario_id, filtro) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/regiao_qtde/' + usuario_id + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckAmbulanciaExcel(usuario_id, filtro, ultimo_id) {
		let qtde = 500;
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/usuario_excel/' + usuario_id + '/' + ultimo_id + '/' + qtde + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}


	
	getCheckAmbulanciaExcelRegiao(usuario_id, filtro, ultimo_id) {
		let qtde = 500;
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkambulancia/regiao_excel/' + usuario_id + '/' + ultimo_id + '/' + qtde + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaCheckAmbulancia(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/checkambulancia', {
				usuario_id: data.usuario_id,
				check_ambulancia_data: data.check_ambulancia_data,
				check_ambulancia_turno: data.check_ambulancia_turno,
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id,
				profissional_id: data.profissional_id,
				veiculo_id: data.veiculo_id,
				check_ambulancia_combustivel: data.check_ambulancia_combustivel,
				check_ambulancia_justificativa: data.check_ambulancia_justificativa,
				check_ambulancia_quilometragem: data.check_ambulancia_quilometragem,
				check_ambulancia_oleo_motor: data.check_ambulancia_oleo_motor,
				check_ambulancia_oleo_motor_obs: data.check_ambulancia_oleo_motor_obs,
				check_ambulancia_agua_radiador: data.check_ambulancia_agua_radiador,
				check_ambulancia_agua_radiador_obs: data.check_ambulancia_agua_radiador_obs,
				check_ambulancia_fluido_freio: data.check_ambulancia_fluido_freio,
				check_ambulancia_fluido_freio_obs: data.check_ambulancia_fluido_freio_obs,
				check_ambulancia_injetor_agua: data.check_ambulancia_injetor_agua,
				check_ambulancia_injetor_agua_obs: data.check_ambulancia_injetor_agua_obs,
				check_ambulancia_freio_de_mao: data.check_ambulancia_freio_de_mao,
				check_ambulancia_freio_de_mao_obs: data.check_ambulancia_freio_de_mao_obs,
				check_ambulancia_partida: data.check_ambulancia_partida,
				check_ambulancia_partida_obs: data.check_ambulancia_partida_obs,
				check_ambulancia_luz_re: data.check_ambulancia_luz_re,
				check_ambulancia_luz_re_obs: data.check_ambulancia_luz_re_obs,
				check_ambulancia_luz_freio: data.check_ambulancia_luz_freio,
				check_ambulancia_luz_freio_obs: data.check_ambulancia_luz_freio_obs,
				check_ambulancia_sirene: data.check_ambulancia_sirene,
				check_ambulancia_sirene_obs: data.check_ambulancia_sirene_obs,
				check_ambulancia_buzina: data.check_ambulancia_buzina,
				check_ambulancia_buzina_obs: data.check_ambulancia_buzina_obs,
				check_ambulancia_ac: data.check_ambulancia_ac,
				check_ambulancia_ac_obs: data.check_ambulancia_ac_obs,
				check_ambulancia_ilu_salao: data.check_ambulancia_ilu_salao,
				check_ambulancia_ilu_salao_obs: data.check_ambulancia_ilu_salao_obs,
				check_ambulancia_tomadas: data.check_ambulancia_tomadas,
				check_ambulancia_tomadas_obs: data.check_ambulancia_tomadas_obs,
				check_ambulancia_cinto: data.check_ambulancia_cinto,
				check_ambulancia_cinto_obs: data.check_ambulancia_cinto_obs,
				check_ambulancia_cones: data.check_ambulancia_cones,
				check_ambulancia_cones_obs: data.check_ambulancia_cones_obs,
				check_ambulancia_extintor: data.check_ambulancia_extintor,
				check_ambulancia_extintor_obs: data.check_ambulancia_extintor_obs,
				check_ambulancia_macaco: data.check_ambulancia_macaco,
				check_ambulancia_macaco_obs: data.check_ambulancia_macaco_obs,
				check_ambulancia_chave_roda: data.check_ambulancia_chave_roda,
				check_ambulancia_chave_roda_obs: data.check_ambulancia_chave_roda_obs,
				check_ambulancia_triangulo: data.check_ambulancia_triangulo,
				check_ambulancia_triangulo_obs: data.check_ambulancia_triangulo_obs,
				check_ambulancia_radio: data.check_ambulancia_radio,
				check_ambulancia_radio_obs: data.check_ambulancia_radio_obs,
				check_ambulancia_gps: data.check_ambulancia_gps,
				check_ambulancia_gps_obs: data.check_ambulancia_gps_obs,
				check_ambulancia_celular: data.check_ambulancia_celular,
				check_ambulancia_celular_obs: data.check_ambulancia_celular_obs,
				check_ambulancia_carregador: data.check_ambulancia_carregador,
				check_ambulancia_carregador_obs: data.check_ambulancia_carregador_obs,
				check_ambulancia_antena: data.check_ambulancia_antena,
				check_ambulancia_antena_obs: data.check_ambulancia_antena_obs,
				check_ambulancia_pneus: data.check_ambulancia_pneus,
				check_ambulancia_pneus_obs: data.check_ambulancia_pneus_obs,
				check_ambulancia_estepe: data.check_ambulancia_estepe,
				check_ambulancia_estepe_obs: data.check_ambulancia_estepe_obs,
				check_ambulancia_portas: data.check_ambulancia_portas,
				check_ambulancia_portas_obs: data.check_ambulancia_portas_obs,
				check_ambulancia_vidros: data.check_ambulancia_vidros,
				check_ambulancia_vidros_obs: data.check_ambulancia_vidros_obs,
				check_ambulancia_lavada: data.check_ambulancia_lavada,
				check_ambulancia_lavada_obs: data.check_ambulancia_lavada_obs,
				check_ambulancia_inicio: data.check_ambulancia_inicio,
				check_ambulancia_fim: data.check_ambulancia_fim,
				check_ambulancia_registro: data.check_ambulancia_registro,
				check_ambulancia_giroflex: data.check_ambulancia_giroflex,
				check_ambulancia_giroflex_obs: data.check_ambulancia_giroflex_obs,
				check_ambulancia_estrobo: data.check_ambulancia_estrobo,
				check_ambulancia_estrobo_obs: data.check_ambulancia_estrobo_obs,
				check_ambulancia_retrovisores: data.check_ambulancia_retrovisores,
				check_ambulancia_retrovisores_obs: data.check_ambulancia_retrovisores_obs,
				check_ambulancia_farois: data.check_ambulancia_farois,
				check_ambulancia_farois_obs: data.check_ambulancia_farois_obs,
				check_ambulancia_piscas: data.check_ambulancia_piscas,
				check_ambulancia_piscas_obs: data.check_ambulancia_piscas_obs,
				check_ambulancia_lanterna_tras: data.check_ambulancia_lanterna_tras,
				check_ambulancia_lanterna_tras_obs: data.check_ambulancia_lanterna_tras_obs,
				check_ambulancia_palheta:data.check_ambulancia_palheta,
				check_ambulancia_palheta_obs:data.check_ambulancia_palheta_obs,
				check_ambulancia_luz_placa:data.check_ambulancia_luz_placa,
				check_ambulancia_luz_placa_obs:data.check_ambulancia_luz_placa_obs,
				check_ambulancia_cilindro_o2:data.check_ambulancia_cilindro_o2,
				check_ambulancia_cilindro_o2_obs:data.check_ambulancia_cilindro_o2_obs,
				check_ambulancia_chave_o2:data.check_ambulancia_chave_o2,
				check_ambulancia_chave_o2_obs:data.check_ambulancia_chave_o2_obs,
				check_ambulancia_maca_rigida:data.check_ambulancia_maca_rigida,
				check_ambulancia_maca_rigida_obs:data.check_ambulancia_maca_rigida_obs,
				check_ambulancia_maca_retratil:data.check_ambulancia_maca_retratil,
				check_ambulancia_maca_retratil_obs:data.check_ambulancia_maca_retratil_obs,
				check_ambulancia_cartao_abast:data.check_ambulancia_cartao_abast,
				check_ambulancia_cartao_abast_obs:data.check_ambulancia_cartao_abast_obs,
				check_ambulancia_obs:data.check_ambulancia_obs,
				check_ambulancia_intercorrencia:data.check_ambulancia_intercorrencia
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaCheckAmbulancia(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/checkambulancia/' + data.check_ambulancia_id, {
				check_ambulancia_id: data.check_ambulancia_id,
				usuario_id: data.usuario_id,
				check_ambulancia_data: data.check_ambulancia_data,
				check_ambulancia_turno: data.check_ambulancia_turno,
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id,
				profissional_id: data.profissional_id,
				veiculo_id: data.veiculo_id,
				check_ambulancia_justificativa: data.check_ambulancia_justificativa,
				check_ambulancia_quilometragem: data.check_ambulancia_quilometragem,
				check_ambulancia_combustivel: data.check_ambulancia_combustivel,
				check_ambulancia_oleo_motor: data.check_ambulancia_oleo_motor,
				check_ambulancia_oleo_motor_obs: data.check_ambulancia_oleo_motor_obs,
				check_ambulancia_agua_radiador: data.check_ambulancia_agua_radiador,
				check_ambulancia_agua_radiador_obs: data.check_ambulancia_agua_radiador_obs,
				check_ambulancia_fluido_freio: data.check_ambulancia_fluido_freio,
				check_ambulancia_fluido_freio_obs: data.check_ambulancia_fluido_freio_obs,
				check_ambulancia_injetor_agua: data.check_ambulancia_injetor_agua,
				check_ambulancia_injetor_agua_obs: data.check_ambulancia_injetor_agua_obs,
				check_ambulancia_freio_de_mao: data.check_ambulancia_freio_de_mao,
				check_ambulancia_freio_de_mao_obs: data.check_ambulancia_freio_de_mao_obs,
				check_ambulancia_partida: data.check_ambulancia_partida,
				check_ambulancia_partida_obs: data.check_ambulancia_partida_obs,
				check_ambulancia_luz_re: data.check_ambulancia_luz_re,
				check_ambulancia_luz_re_obs: data.check_ambulancia_luz_re_obs,
				check_ambulancia_luz_freio: data.check_ambulancia_luz_freio,
				check_ambulancia_luz_freio_obs: data.check_ambulancia_luz_freio_obs,
				check_ambulancia_sirene: data.check_ambulancia_sirene,
				check_ambulancia_sirene_obs: data.check_ambulancia_sirene_obs,
				check_ambulancia_buzina: data.check_ambulancia_buzina,
				check_ambulancia_buzina_obs: data.check_ambulancia_buzina_obs,
				check_ambulancia_ac: data.check_ambulancia_ac,
				check_ambulancia_ac_obs: data.check_ambulancia_ac_obs,
				check_ambulancia_ilu_salao: data.check_ambulancia_ilu_salao,
				check_ambulancia_ilu_salao_obs: data.check_ambulancia_ilu_salao_obs,
				check_ambulancia_tomadas: data.check_ambulancia_tomadas,
				check_ambulancia_tomadas_obs: data.check_ambulancia_tomadas_obs,
				check_ambulancia_cinto: data.check_ambulancia_cinto,
				check_ambulancia_cinto_obs: data.check_ambulancia_cinto_obs,
				check_ambulancia_cones: data.check_ambulancia_cones,
				check_ambulancia_cones_obs: data.check_ambulancia_cones_obs,
				check_ambulancia_extintor: data.check_ambulancia_extintor,
				check_ambulancia_extintor_obs: data.check_ambulancia_extintor_obs,
				check_ambulancia_macaco: data.check_ambulancia_macaco,
				check_ambulancia_macaco_obs: data.check_ambulancia_macaco_obs,
				check_ambulancia_chave_roda: data.check_ambulancia_chave_roda,
				check_ambulancia_chave_roda_obs: data.check_ambulancia_chave_roda_obs,
				check_ambulancia_triangulo: data.check_ambulancia_triangulo,
				check_ambulancia_triangulo_obs: data.check_ambulancia_triangulo_obs,
				check_ambulancia_radio: data.check_ambulancia_radio,
				check_ambulancia_radio_obs: data.check_ambulancia_radio_obs,
				check_ambulancia_gps: data.check_ambulancia_gps,
				check_ambulancia_gps_obs: data.check_ambulancia_gps_obs,
				check_ambulancia_celular: data.check_ambulancia_celular,
				check_ambulancia_celular_obs: data.check_ambulancia_celular_obs,
				check_ambulancia_carregador: data.check_ambulancia_carregador,
				check_ambulancia_carregador_obs: data.check_ambulancia_carregador_obs,
				check_ambulancia_antena: data.check_ambulancia_antena,
				check_ambulancia_antena_obs: data.check_ambulancia_antena_obs,
				check_ambulancia_pneus: data.check_ambulancia_pneus,
				check_ambulancia_pneus_obs: data.check_ambulancia_pneus_obs,
				check_ambulancia_estepe: data.check_ambulancia_estepe,
				check_ambulancia_estepe_obs: data.check_ambulancia_estepe_obs,
				check_ambulancia_portas: data.check_ambulancia_portas,
				check_ambulancia_portas_obs: data.check_ambulancia_portas_obs,
				check_ambulancia_vidros: data.check_ambulancia_vidros,
				check_ambulancia_vidros_obs: data.check_ambulancia_vidros_obs,
				check_ambulancia_lavada: data.check_ambulancia_lavada,
				check_ambulancia_lavada_obs: data.check_ambulancia_lavada_obs,
				check_ambulancia_registro: data.check_ambulancia_registro,
				check_ambulancia_inicio: data.check_ambulancia_inicio,
				check_ambulancia_fim: data.check_ambulancia_fim,
				check_ambulancia_giroflex: data.check_ambulancia_giroflex,
				check_ambulancia_giroflex_obs: data.check_ambulancia_giroflex_obs,
				check_ambulancia_estrobo: data.check_ambulancia_estrobo,
				check_ambulancia_estrobo_obs: data.check_ambulancia_estrobo_obs,
				check_ambulancia_retrovisores: data.check_ambulancia_retrovisores,
				check_ambulancia_retrovisores_obs: data.check_ambulancia_retrovisores_obs,
				check_ambulancia_farois: data.check_ambulancia_farois,
				check_ambulancia_farois_obs: data.check_ambulancia_farois_obs,
				check_ambulancia_piscas: data.check_ambulancia_piscas,
				check_ambulancia_piscas_obs: data.check_ambulancia_piscas_obs,
				check_ambulancia_lanterna_tras: data.check_ambulancia_lanterna_tras,
				check_ambulancia_lanterna_tras_obs: data.check_ambulancia_lanterna_tras_obs,
				check_ambulancia_palheta:data.check_ambulancia_palheta,
				check_ambulancia_palheta_obs:data.check_ambulancia_palheta_obs,
				check_ambulancia_luz_placa:data.check_ambulancia_luz_placa,
				check_ambulancia_luz_placa_obs:data.check_ambulancia_luz_placa_obs,
				check_ambulancia_cilindro_o2:data.check_ambulancia_cilindro_o2,
				check_ambulancia_cilindro_o2_obs:data.check_ambulancia_cilindro_o2_obs,
				check_ambulancia_chave_o2:data.check_ambulancia_chave_o2,
				check_ambulancia_chave_o2_obs:data.check_ambulancia_chave_o2_obs,
				check_ambulancia_maca_rigida:data.check_ambulancia_maca_rigida,
				check_ambulancia_maca_rigida_obs:data.check_ambulancia_maca_rigida_obs,
				check_ambulancia_maca_retratil:data.check_ambulancia_maca_retratil,
				check_ambulancia_maca_retratil_obs:data.check_ambulancia_maca_retratil_obs,
				check_ambulancia_cartao_abast:data.check_ambulancia_cartao_abast,
				check_ambulancia_cartao_abast_obs:data.check_ambulancia_cartao_abast_obs,
				check_ambulancia_obs:data.check_ambulancia_obs,
				check_ambulancia_intercorrencia:data.check_ambulancia_intercorrencia
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCheckAmbulancia(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checkambulancia/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCheckAmbulanciaAdmin(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checkambulancia/admin/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaIntercorrencia(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/checkambulancia/' + data.check_ambulancia_id, {
				check_ambulancia_intercorrencia:data.check_ambulancia_intercorrencia
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
				err => {
					reject(err);
				});
		});
	}

	relatorio(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/checkambulancia/relatorio', {
				cliente_id:data.cliente_id,
				unidade_id:data.unidade_id,
				veiculo_id:data.veiculo_id,
				check_ambulancia_turno:data.check_ambulancia_turno,
				data_inicio: data.data_inicio,
				data_fim: data.data_fim,
				obs:data.obs,
				usuario: data.usuario,
				especialidade_veiculo_id: data.especialidade_veiculo_id___veiculo,
				profissional: data.profissional_id___profissional
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
				err => {
					reject(err);
				});
		});
	}

	relatorioExcel(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/checkambulancia/relatorio-excel', {
				cliente_id:data.cliente_id,
				unidade_id:data.unidade_id,
				veiculo_id:data.veiculo_id,
				check_ambulancia_turno:data.check_ambulancia_turno,
				data_inicio: data.data_inicio,
				data_fim: data.data_fim,
				obs:data.obs,
				usuario: data.usuario,
				especialidade_veiculo_id: data.especialidade_veiculo_id___veiculo,
				profissional: data.profissional_id___profissional				
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
				err => {
					reject(err);
				});
		});
	}
}
